module.exports = __webpack_public_path__ + "static/008275-c80bd1bfa4fc80242763c2c7a615ec36.jpg";